export default __webpack_public_path__ + "static/media/tolltip-info.5953e624.svg";